<div class="menu-vendre">
  <div class="menu-main">
    <div class="menu-main-item">
      <button type="button" class="btn-clean" (click)="openModalEstimation()">
        <div class="menu-main-item-icon">
          <img width="38" height="40" src="assets/svg/estimer-bien.svg" alt="">
        </div>
      </button>
      <button type="button" class="btn-clean lien-txt text-start" (click)="openModalEstimation()">
        <div class="menu-main-item-text">
          <span class="bold-base">Estimer votre bien</span>
          <span class="normal-sm">Obtenez une estimation rapide et gratuite</span>
        </div>
      </button>
      <app-modal-estimation-bien [externalOpen]="openModal" [hideBtnOpen]="true"></app-modal-estimation-bien>
    </div>
    <div class="menu-main-item">
      <a [routerLink]="['/nos-formules-the-door-man.html']">
        <div class="menu-main-item-icon">
          <img width="34" height="40" src="assets/svg/choisir-mandat.svg" alt="">
        </div>
      </a>
      <a [routerLink]="['/nos-formules-the-door-man.html']" class="lien-txt">
        <div class="menu-main-item-text">
          <span class="bold-base">Choisir votre mandat</span>
          <span class="normal-sm">Parmi 3 formules pensées pour vous</span>
        </div>
      </a>
    </div>
<!--    <div class="menu-main-item">-->
<!--      <a [routerLink]="['/accueil']" fragment="ancre-success-stories">-->
<!--        <div class="menu-main-item-icon">-->
<!--          <img src="assets/svg/success-stories.svg" alt="Témoignages Opinion System">-->
<!--        </div>-->
<!--      </a>-->
<!--      <a [routerLink]="['/accueil']" fragment="ancre-success-stories" class="lien-txt">-->
<!--        <div class="menu-main-item-text">-->
<!--          <span class="bold-base">Success stories</span>-->
<!--          <span class="normal-sm">Découvrez les témoignages de vendeurs comme vous</span>-->
<!--        </div>-->
<!--      </a>-->
<!--    </div>-->
  </div>

  <div class="menu-secondary">
    <div class="bold-xl"><span class="seconday01dark">Propriétaire</span> : vous souhaitez vendre votre bien ?</div>
    <div class="semibold-sm gray700">Confiez-nous votre bien immobilier et vendez dans les meilleures conditions.</div>
    <button [routerLink]="['/amis-tdm/liste']" routerLinkActive="router-link-active"  type="button" class="btn btn-gold external-link">Contacter un Conseiller</button>
  </div>
</div>
